import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Layout from "./../components/Layout/Layout";
import CtaSection from "./CtaSection";
import FeaturesSection from "./FeaturesSection";
import WhyChooseSection from "./WhyChooseSection";
import AppFeatureSection from "./AppFeatureSection";
import AppDownloadSection from "./AppDownloadSection";
import { Fade } from "react-reveal";


const Home = () => {
  return (
    <Layout>
      <HelmetProvider>
        <Helmet>
          <title>Finkoda | Empowering Your Financial Future</title>
          <meta name="description" content="Explore personalized advice, investment strategies, and money management tips to secure your financial future." />
          <meta name="keywords" content="Finkoda, financial solutions, investments, financial planning, banking, assets, finance app, financial advice, finance company, finance management, finance tools, business finance, stock market, insurance, personal finance, Finanza Madurai"/>
          <link rel="canonical" href="https://finkoda.com/"/>
          <link rel="alternate" media="only screen and (max-width: 640px)" href="https://finkoda.com/"/>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content="Finkoda"/>
          <meta property="og:url" content="https://finkoda.com/"/>
          <meta property="og:image" content="%PUBLIC_URL%/logo.png"/>
          <meta property="og:description" content="Finkoda is your trusted partner in achieving financial confidence, offering personalized solutions, expert guidance, and a supportive community to help you navigate your financial journey with simplicity and clarity." />
          
          {/* Twitter */}
          <meta name="twitter:card" content="summary"/>
          <meta name="twitter:title" content="Finkoda"/>
          <meta name="twitter:site" content="@Finkoda"/>
          <meta name="twitter:description" content="Finkoda is your trusted partner in achieving financial confidence, offering personalized solutions, expert guidance, and a supportive community to help you navigate your financial journey with simplicity and clarity." />
          <meta name="twitter:image" content="%PUBLIC_URL%/logo.png"/>
          <meta name="twitter:image:alt" content="Finkoda"/>


        </Helmet>
      </HelmetProvider>
    <Fade left duration={800} delay={0}>
        <AppFeatureSection />
      </Fade>

      <Fade right duration={800} delay={300}>
        <FeaturesSection />
      </Fade>

      <Fade left duration={800} delay={600}>
        <WhyChooseSection />
      </Fade>

      <Fade bottom duration={800} delay={900}>
        <CtaSection />
      </Fade>

      <Fade bottom duration={800} delay={1200}>
        <AppDownloadSection />
      </Fade>
    </Layout>
  );
};

export default Home;
